#import '../fragments/coupon-fragment.graphql'

fragment PlanFragment on Plan {
    product
    code
    description
    cycleText
    planHighlights
    priorFeaturesText
    priceUnit
    price
    shortenedName
    stickerPrice
    isActive
    quantity
    productQuantity
    isLegacy
    isFake
    subtitleText
    coupon {
        ...CouponFragment
    }
    nameDisplay
    name
}
